export default __webpack_public_path__ + "static/media/logo.dbfb15e3.svg";